export interface BannedAddressEntry {
  /** ISO country code, exact match (e.g. 'US'). */
  countryCode: string;
  /** State code, exact match (e.g. 'WY'). */
  stateCode: string;
  /** 5-digit ZIP base; a ZIP+4 value sharing this prefix also matches. */
  postalCode: string;
  /** City name in canonical (normalized) form. */
  city: string;
  /** Canonical street tokens that must ALL be present in line1+line2+line3. */
  streetTokens: string[];
}

// #13189 — registered-agent buildings whose addresses cannot be used as an IOR
// business address. Suite/unit is intentionally NOT matched: the whole building is banned.
export const BANNED_IOR_ADDRESSES: BannedAddressEntry[] = [
  // 30 N Gould St, Sheridan, WY 82801 (mass registered-agent address)
  { countryCode: 'US', stateCode: 'WY', postalCode: '82801', city: 'SHERIDAN', streetTokens: ['30', 'N', 'GOULD', 'ST'] },
];
